import { css } from '@/styled-system/css';

export const accordionRootStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  gap: '400',
  listStyle: 'none',
  padding: 'none',
  margin: 'none',
});

export const accordionItemStyles = css.raw({
  listStyle: 'none',
  borderWidth: '0',
  borderRadius: 'none',
});

export const cardPanelStyles = css.raw({
  paddingInline: 'none',
  paddingBlockStart: 'none',
  paddingBlockEnd: 'none',
  borderTopWidth: '0',
  borderBottomLeftRadius: 'none',
  borderBottomRightRadius: 'none',
  backgroundColor: 'transparent',
});

// Positioning context for a control rendered as a sibling of the header trigger.
export const cardHeaderRowStyles = css.raw({
  position: 'relative',
});

// Must use the same longhands Accordion.Header sets; a `padding` shorthand won't reliably
// override them in Panda's atomic cascade.
export const accordionHeaderStyles = css.raw({
  paddingBlock: '400',
  paddingInline: '400',
});

// Variant for a header that shares its row with a sibling control (e.g. an overflow menu),
// reserving room at the end so the header content doesn't run underneath it.
export const accordionHeaderWithTrailingControlStyles = css.raw({
  paddingBlock: '400',
  paddingInlineStart: '400',
  paddingInlineEnd: '1600',
  // Accordion.Header's child needs to be shrinkable for the header content to truncate.
  '& > [data-c11n-component=Box]': {
    minWidth: 0,
  },
});
